import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.551 5.146a11.248 11.248 0 0 1 18.898 0 9.55 9.55 0 0 1 1.325 3.215c.364 1.554.431 3.172.373 4.678-.106 2.737-.832 5.222-2.316 7.042C19.321 21.934 17.105 23 14.263 23H12a2 2 0 1 1 2-2h.263c2.293 0 3.92-.835 5.018-2.182A7.216 7.216 0 0 0 20.344 17H18V9h2.863a8.364 8.364 0 0 0-.04-.2c-.22-.932-.559-1.802-1.054-2.57A9.25 9.25 0 0 0 12 2a9.248 9.248 0 0 0-7.769 4.23A7.604 7.604 0 0 0 3.137 9H6v8H4a3 3 0 0 1-3-3l.003-4.077c.125-1.623.548-3.229 1.548-4.777ZM21.133 11H20v4h.925c.12-.638.196-1.32.223-2.039.026-.66.024-1.317-.015-1.961ZM3 11v3a1 1 0 0 0 1 1v-4H3Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionSupport24 = createIcon(IconComponent);